"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTransport = exports.Transport = exports.getEventData = exports.PROD_FRAME_URL = exports.DEBUG_FRAME_URL = void 0;
var media_image_studio_common_1 = require("@wix/media-image-studio-common");
var fbemitter_1 = require("fbemitter");
var sendBiEvent_1 = require("./bi/sendBiEvent");
var url_1 = require("./utils/url");
var PROD_FRAME_DOMAIN = 'https://manage.wix.com';
var PROD_EDITOR_X_FRAME_DOMAIN = 'https://manage.editorx.com';
var DEBUG_FRAME_DOMAIN = 'https://local.wix.com:3010';
exports.DEBUG_FRAME_URL = DEBUG_FRAME_DOMAIN;
exports.PROD_FRAME_URL = (0, url_1.getMediaImageStudioProdUrl)();
var ALLOWED_POST_MESSAGE_ORIGINS = [
    DEBUG_FRAME_DOMAIN,
    PROD_FRAME_DOMAIN,
    PROD_EDITOR_X_FRAME_DOMAIN,
    '',
];
var getEventData = function (event) {
    return event.data;
};
exports.getEventData = getEventData;
var Transport = /** @class */ (function () {
    function Transport(targetFrame, options) {
        if (options === void 0) { options = {
            debug: false,
            mediaRoot: '',
            initiator: '',
        }; }
        var _this = this;
        this.targetFrame = targetFrame;
        this.options = options;
        this.messagesEmitter = new fbemitter_1.EventEmitter();
        this.readyPromise = undefined;
        this.handleMessage = function (event) {
            if (ALLOWED_POST_MESSAGE_ORIGINS.indexOf(event.origin) === -1) {
                return;
            }
            var eventData = (0, exports.getEventData)(event);
            if (!eventData) {
                var _a = _this.options, initiator = _a.initiator, mediaRoot = _a.mediaRoot;
                (0, sendBiEvent_1.sendBiEvent)({
                    evid: 36,
                    action: 'Invalid incoming message data',
                    initiatorName: initiator,
                    mediaRoot: mediaRoot,
                });
                return;
            }
            _this.messagesEmitter.emit(eventData.type, eventData.data);
        };
    }
    Transport.prototype.init = function () {
        window.addEventListener('message', this.handleMessage);
        this.waitForReady().catch(function (error) {
            console.error('There was an error waiting for ready', error);
        });
    };
    Transport.prototype.destroy = function () {
        window.removeEventListener('message', this.handleMessage);
    };
    Transport.prototype.sendMessage = function (message) {
        var _this = this;
        var contentWindow = this.targetFrame.contentWindow;
        if (!contentWindow) {
            throw Error("can not send message \"".concat(JSON.stringify(message), "\", no contentWindow"));
        }
        this.waitForReady()
            .then(function () {
            contentWindow.postMessage(message, _this.getTargetOrigin());
        })
            .catch(function (error) {
            console.error('There was an error waiting for ready', error);
        });
    };
    Transport.prototype.waitForMessage = function (postMessageType) {
        var _this = this;
        return new Promise(function (resolve) {
            _this.messagesEmitter.once(postMessageType, function (data) {
                resolve(data);
            });
        });
    };
    Transport.prototype.waitForClose = function () {
        return this.waitForMessage(media_image_studio_common_1.POST_MESSAGE_TYPES.FRAME_CLOSE);
    };
    Transport.prototype.waitForImageData = function () {
        var _this = this;
        return new Promise(function (resolve) {
            _this.messagesEmitter.once(media_image_studio_common_1.POST_MESSAGE_TYPES.IMAGE_DATA, function (_a) {
                var imageBuffer = _a.imageBuffer, mime = _a.mime;
                resolve(new Blob([new Uint8Array(imageBuffer)], { type: mime }));
            });
        });
    };
    Transport.prototype.waitForUploadedImage = function () {
        return this.waitForMessage(media_image_studio_common_1.POST_MESSAGE_TYPES.UPLOADED_IMAGE);
    };
    Transport.prototype.waitForUploadFailed = function () {
        return this.waitForMessage(media_image_studio_common_1.POST_MESSAGE_TYPES.UPLOADED_IMAGE_FAILED);
    };
    Transport.prototype.waitForReady = function () {
        if (!this.readyPromise) {
            this.readyPromise = this.waitForMessage(media_image_studio_common_1.POST_MESSAGE_TYPES.READY);
        }
        return this.readyPromise;
    };
    Transport.prototype.getTargetOrigin = function () {
        return this.options.debug ? exports.DEBUG_FRAME_URL : exports.PROD_FRAME_URL;
    };
    return Transport;
}());
exports.Transport = Transport;
var createTransport = function (targetFrame, options) {
    if (options === void 0) { options = {
        debug: false,
        mediaRoot: '',
        initiator: '',
    }; }
    return new Transport(targetFrame, options);
};
exports.createTransport = createTransport;
//# sourceMappingURL=transport.js.map